import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export const BaseNode = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & {
    selected?: boolean
    disableDefaultShadow?: boolean
  }
>(({ className, selected, disableDefaultShadow, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'relative rounded-md border bg-card p-0 text-card-foreground',
      className,
      'hover:ring-1',
      // Add selection styling when selected
      selected ? 'border-muted-foreground border-amber-500' : ''
    )}
    // Remove the inline boxShadow style to let CSS handle all shadows
    tabIndex={0}
    {...props}
  />
))

BaseNode.displayName = 'BaseNode'
